import { useFormField } from '@/components/Formie/useForm';
import { createField } from '@/lib/parsers/form';
import { addToDistinctArray, removeFromDistinctArray } from '@/lib/helpers';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import { FieldErrors } from './FieldErrors';

export const Field_Checkboxes = createField<'Field_Checkboxes'>(({ field, ..._props }) => {
  const {
    name,
    handle,
    layout,
    required,
    options,
    multi: _multi,
    instructions,
    defaultValue: _defaultValue,
    labelPosition,
  } = field;

  const { value, setValue, error, errors } = useFormField(handle, 'multi');

  const handleChange =
    (optionValue: string) => (_ev: React.SyntheticEvent<Element, Event>, checked: boolean) => {
      setValue(
        checked
          ? addToDistinctArray(value, optionValue)
          : removeFromDistinctArray(value, optionValue)
      );
    };

  return (
    <FormControl required={required} error={error}>
      <FormLabel component="legend" sx={{ mb: 1 }} hidden={labelPosition === 'hidden'}>
        {name}
      </FormLabel>
      <FormHelperText>{instructions}</FormHelperText>
      <FormGroup row={layout === 'horizontal'} sx={{ mb: 1 }}>
        {options.map((v) => (
          <FormControlLabel
            key={v.value}
            control={
              <Checkbox
                style={{ color: 'currentColor' }}
                // icon={<Icon name="checkboxEmpty" />}
                // checkedIcon={<Icon name="checkbox" />}
                checked={value.includes(v.value)}
                focusRipple={false}
                onChange={handleChange(v.value)}
                name={v.value}
                aria-describedby={`${handle}-field-error`}
              />
            }
            label={v.label}
          />
        ))}
      </FormGroup>
      <FieldErrors id={`${handle}-field-error`} errors={errors} />
    </FormControl>
  );
});
